<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.5 3.5C3.5 2.94772 3.05228 2.5 2.5 2.5C1.94772 2.5 1.5 2.94772 1.5 3.5V7.25V11C1.5 11.5523 1.94772 12 2.5 12C3.05228 12 3.5 11.5523 3.5 11V8.25H8V11C8 11.5523 8.44772 12 9 12C9.55229 12 10 11.5523 10 11V7.25V3.5C10 2.94772 9.55229 2.5 9 2.5C8.44772 2.5 8 2.94772 8 3.5V6.25H3.5V3.5ZM15 7C15 6.6312 14.797 6.29234 14.4719 6.11833C14.1467 5.94431 13.7522 5.96338 13.4453 6.16795L11.9453 7.16795C11.4858 7.4743 11.3616 8.09517 11.6679 8.5547C11.9623 8.99623 12.547 9.12816 13 8.86607V13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13V7Z"
  />
</template>
